<!-- SVG Divider -->
<div id="SVGDivider5" class="position-relative z-index-2 overflow-hidden">
  <figure class="clearfix d-none d-xl-block position-fixed z-index-n1" style="top:-1%; left:25%;">
    <img width="120%" height="120%" appLazyload="components/africa-outline.svg"
         alt="Africa Silhouette"
         data-parent="#SVGDivider5">
  </figure>
  <figure class="clearfix d-none d-lg-block d-xl-none position-fixed z-index-n1" style="top:10%; left:-5%;">
    <img width="120%" height="120%" style="position: absolute"
         appLazyload="components/africa-outline.svg" alt="Africa Silhouette"
         data-parent="#SVGDivider5">
  </figure>
  <figure class="clearfix d-none d-md-block d-lg-none position-fixed z-index-n1" style="top:2%; left:5%;">
    <img width="115%" height="115%" appLazyload="components/africa-outline.svg"
         alt="Africa Silhouette"
         data-parent="#SVGDivider5">
  </figure>
  <figure class="clearfix d-md-none position-fixed z-index-n1" style="top:10%; left:-5%;">
    <img width="105%" height="105%" appLazyload="components/africa-outline.svg"
         alt="Africa Silhouette"
         data-parent="#SVGDivider5">
  </figure>

  <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
    <div class="position-relative">
      <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
        <div class="row pt-7 space-bottom-1 mobilePad">
          <!-- Core Content -->
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-7 mb-lg-0">
            <!-- Header -->
            <!-- End Header -->
            <div class="container space-1 space-top-lg-1">
              <div class="row justify-content-lg-between align-items-lg-center">
                <div class="col-lg-6 mb-9 mb-lg-0">
                  <div class="mb-5">
                    <div class="respTextH1">
                      <h1 class="font-weight-medium mb-4 text-white">About Us</h1>
                    </div>
                    <p>Our story began when a group of family members boarded the plane to Tanzania,
                      Africa.
                      We were about to embark on the adventure of a lifetime. We spent 15
                      life-changing days trekking the tallest
                      free-standing mountain in the world and immersing ourselves in one of the
                      planet’s best ranked safaris.
                      As our overseas vacation came to an end, we were left with an undeniable
                      itch to share our experience, and to
                      help others like yourself to dive into the wonders of Tanzania.</p>
                  </div>
                </div>

                <div class="col-lg-6 col-sm-12">
                  <div class="">
                    <img appLazyload="kopa-branding/full-logo.svg" class="kopalogo"
                         alt="Kopa Tours logo">
                  </div>
                </div>
              </div>
            </div>
            <div class="container col-12 respText">
              <h2>
                <span class="font-weight-medium text-white respText">Meet The Founders</span>
              </h2>
            </div>
            <!-- Team Section -->
            <div class="container mt-5 mb-5 overflow-hidden">
              <!-- Team Carousel -->
              <carousel
                [overflowCellsLimit]="1"
                [cellsToShow]="getCellsToShow()"
                [height]="getCarouselHeight()"
                [arrows]="shouldShowArrows()"
                id="team">
                <div class="carousel-cell pb-4">
                  <!-- Team -->
                  <img class="img-fluid w-100 rounded respHeight"
                       appLazyload="800x800/david-headshot.jpg" alt="David Straily">
                  <div class="card border-0 shadow-sm mt-n6 mx-3">
                    <div class="card-body text-center p-4">
                      <h4 class="h6 mb-1">David Straily</h4>
                      <p class="font-size-1 mb-0">Explore with heart means <span
                        class="font-weight-semi-bold">committing yourself 100% to the experience at hand.</span>
                      </p>
                    </div>
                  </div>
                  <!-- End Team -->
                </div>

                <div class="carousel-cell pb-4">
                  <!-- Team -->
                  <img class="img-fluid w-100 rounded respHeight"
                       appLazyload="800x800/sara-headshot.jpg" alt="Sara Sarafa">
                  <div class="card border-0 shadow-sm mt-n6 mx-3">
                    <div class="card-body text-center p-4">
                      <h4 class="h6 mb-1">Sara Sarafa</h4>
                      <p class="font-size-1 mb-0">Explore with heart means <span
                        class="font-weight-semi-bold">immersing yourself in a new community.</span>
                      </p>
                    </div>
                  </div>
                  <!-- End Team -->
                </div>

                <div class="carousel-cell pb-4">
                  <!-- Team -->
                  <img class="img-fluid w-100 rounded respHeight"
                       appLazyload="800x800/daniel-headshot.jpg" alt="Daniel Sarafa">
                  <div class="card border-0 shadow-sm mt-n6 mx-3">
                    <div class="card-body text-center p-4">
                      <h4 class="h6 mb-1">Daniel Sarafa</h4>
                      <p class="font-size-1 mb-0">Explore with heart means <span
                        class="font-weight-semi-bold">having experiences outside of your comfort zone.</span>
                      </p>
                    </div>
                  </div>
                  <!-- End Team -->
                </div>

                <div class="carousel-cell pb-4">
                  <!-- Team -->
                  <img class="img-fluid w-100 rounded respHeight"
                       appLazyload="800x800/kellie-headshot.jpg" alt="Kellie Straily">
                  <div class="card border-0 shadow-sm mt-n6 mx-3">
                    <div class="card-body text-center p-4">
                      <h4 class="h6 mb-1">Kellie Straily</h4>
                      <p class="font-size-1 mb-0">Explore with heart means <span
                        class="font-weight-semi-bold">reflecting on learnings from the new people you meet.</span>
                      </p>
                    </div>
                  </div>
                  <!-- End Team -->
                </div>
              </carousel>
              <!-- End Team Carousel -->
            </div>
            <div class="container space-1 space-top-lg-1">
              <div class="row justify-content-lg-between align-items-lg-center">
                <div class="col-lg-6 order-lg-2 mb-9 mb-lg-0">
                  <div class="mb-5 respText">
                    <h2 class="font-weight-medium mb-4 text-white">The Origin of Kopa</h2>
                  </div>
                  <p class="mt-5 mb-5 mobileMargin">
                    The sky was a shade of midnight, the eyes in the room glimmered off the
                    dimly lit lantern in the corner. Of the dozens of tents at the campground,
                    ours was the only one aglow.
                    <br/><br/>
                    <span class="h5">Sara</span>, dust-caked and jaw set -- having summited
                    Kilimanjaro just 10 hours previous -- had her eyes locked in on the playing
                    card in <span class="h5">Samwel</span>'s hand. The tension in the mess tent
                    was palpable; she was NOT going to lose this triple-match showdown of "Last
                    Card."
                    <br/><br/>
                    Sara was our final hope to defeat <span class="h5">Samwel</span>, the "<span
                    class="h5">Card Shark of Kilimanjaro</span>."
                    <br/><br/>
                    We four Kopa founders and our two mountain guides were certainly tired, and
                    it was well past bedtime -- but it didn't matter, we were having fun.
                    Kopa means "<span
                    class="h5 font-weight-bold">suit of hearts</span>" in
                    Swahili, and in everything we do at Kopa we do it with PASSION & we do it to
                    have FUN. Vacations aren't about the box ticking, or the Instagram photos --
                    they are about immersing yourself in an experience.
                    <br/><br/>
                    Give your next vacation the <span class="h5 font-weight-bold">KOPA TOUCH</span>.
                  </p>
                </div>

                <div class="col-lg-6 order-lg-1">
                  <div id='SVGDivider1' class="position-relative z-index-2 overflow-hidden">
                    <!-- Photo Gallery -->
                    <div appFancyPhotoGallery [mosaic]="true"
                         [photoGallery]="photoGallery"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="row justify-content-lg-between align-items-lg-center">
                <div class="col-lg-12 mb-9 mb-lg-0 mobileBottom">
                  <div class="respText deskHeader">
                    <h2 id="whybook">
                      <strong class="text-white">Why Book With Us?</strong>
                    </h2>
                  </div>
                  <p class="mobileMargin">
                    Every Kopa employee has experienced the heights of Kilimanjaro and the thrills
                    of Safaris - we can discuss our first-hand experiences and offer advice to you. We
                    can picture you now - <i>making that final step as you reach the Roof of Africa and cruising through
                    the
                    wide open Serengeti plains</i> - let us help you make your African adventure a success!<br/><br/>
                    Read about our values below to understand why you should trust us with your travel.</p>
                </div>
              </div>
            </div>
            <div class="container space-top-lg-1">
              <div class="row justify-content-lg-between align-items-lg-center">
                <div class="col-lg-12 mb-4 mb-lg-0 respText">
                  <div class="respText">
                    <h3 class="text-white valuesHeader">Our Values</h3>
                  </div>
                  <div class="row topMargin respText respJust">
              <span class="col-1 mb-4 pillarIcon">
                <img class="ml-2 mr-3 mobileImg"
                     appLazyload="kopa-branding/geo-heart.svg" alt="Kopa Tours Geometric Heart"
                     style="width: 5rem; height: 5rem; ">
              </span>
                    <span class="mt-2 col-10 mobileValues"><i class="font-weight-bold">Kopa</i>&nbsp; means "suit of hearts" in Swahili and in everything we do at <i
                      class="font-weight-bold">Kopa Tours</i>&nbsp; we do it with PASSION & we do it to have FUN.
                    From the plains to peaks, we have all the details covered; when you book with us, all you need to do is focus on the fun.<br
                        *ngIf="isMobile()"><br *ngIf="isMobile()">
              </span>
                    <br><br>
                  </div>
                  <div class="row topMargin respText respJust">
              <span class="col-1 mb-4 pillarIcon">
                  <img class="ml-2 mr-3 mobileImg" appLazyload="icons/transparency.svg" alt="SVG"
                       style="width: 5rem; height: 5rem;">
              </span>
                    <span class="mt-1 col-10 mobileValues">Kopa Tours is one of the few Tanzanian tour providers to offer a full-service online booking process.
                  Personalized PDF itineraries, e-mail notifications leading up to your trip; everything has been streamlined for your ease of use. We've also got one of the most flexible reschedule policies in the industry.
                  At Kopa Tours, we are optimized for your <i class="font-weight-bold">convenience</i>.
                    <br *ngIf="isMobile()"><br *ngIf="isMobile()">
              </span>
                    <br/><br/>
                  </div>
                  <div class="row topMargin respText respJust">
              <span class="col-1 mb-4 pillarIcon">
                <img class="ml-2 mr-3 mobileImg" appLazyload="icons/trophy.svg" alt="SVG"
                     style="width: 5rem; height: 5rem;">
              </span>
                    <span class="mt-1 col-10 mobileValues">Every trip is crafted uniquely to <i
                      class="font-weight-bold">you</i> - because we appreciate that no person is the same.
                      Every booking comes with a Kopa Tours team member exclusively dedicated to you and your party.
                      Booking and beyond, we will be with you throughout the entire process and will ensure everything leading up to your trip is exactly to your expectations.<br
                        *ngIf="isMobile()"><br *ngIf="isMobile()">
              </span>
                    <br/><br/>
                  </div>
                  <div class="row topMargin respText respJust">
              <span class="col-1 mb-4 mb-md-2 pillarIcon">
                <img class="ml-2 mr-3 mobileImg" appLazyload="icons/diversity.svg" alt="SVG"
                     style="width: 5rem; height: 5rem;">
              </span>
                    <span class="mt-1 col-10 mobileValues diversity">We are a team that is <i class="font-weight-bold">united</i>&nbsp; by a love of travel.
                      Our team has traveled to 40+ countries; none more beautiful than Tanzania. The eye never forgets what the heart has seen - capture your own Tanzanian moment today!
              </span>
                    <br/><br/>
                  </div>
                  <!-- End Quick Details -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Core Content -->

        <div class="container">
          <h3 class="text-center space-top-1 space-bottom-1">
            <strong class="text-white">Awards & Press</strong>
          </h3>
          <app-awards-and-press></app-awards-and-press>
        </div>

        <!-- Testimonials -->
        <h3 class="text-center space-top-2 space-bottom-1">
          <strong class="text-white">Testimonials</strong>
        </h3>
        <app-testimonials></app-testimonials>
        <div class="row mb-6">
          <div class="col-md-6 offset-md-3 col-sm-12 leftBookmundiMarg">
            <div id="bookmundi-widget-sidebar"><a href="https://www.bookmundi.com/companies/kopa-tours/c2163"
                                                  target="_blank" id="bookmundi-link">Kopa Tours</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End SVG Divider -->
